import React from 'react';

interface TeamMemberProps {
  name: string;
  role: string;
  imageUrl: string;
}

export const TeamMember: React.FC<TeamMemberProps> = ({
  name,
  role,
  imageUrl
}) => {
  return (
    <div className="group relative">
      <div className="relative h-80 w-full overflow-hidden rounded-lg bg-white">
        <img
          src={imageUrl}
          alt={name}
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="mt-4 text-center">
        <h3 className="text-lg font-semibold">{name}</h3>
        <p className="text-sm text-gray-600">{role}</p>
      </div>
    </div>
  );
};